import { render, staticRenderFns } from "./dialog-follow-conversation.vue?vue&type=template&id=1ec743bf&scoped=true&"
import script from "./dialog-follow-conversation.vue?vue&type=script&lang=js&"
export * from "./dialog-follow-conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec743bf",
  null
  
)

export default component.exports